/* ============================================================
   ANDHEKA — theme.js
   Architecture: everything is either (a) a GLOBAL, bind-once,
   fully-delegated listener (works forever, survives Swup content
   swaps automatically), or (b) a PER-PAGE behaviour that is re-run
   by refreshPageBehaviors() on first load AND after every Swup
   'content:replace' (IntersectionObservers, size-guide sync).
   This is what makes the green wipe blink-free: Swup swaps
   #main-content via fetch (no real reload), our loader panel
   covers the screen the whole time, header/footer/cart persist.
   ============================================================ */
(function(){
  'use strict';
  var CFG = (window.Andheka && window.Andheka.settings) || {};

  function $(s,c){ return (c||document).querySelector(s); }
  function $all(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); }
  function formatMoney(cents){ return '\u20b9' + (cents/100).toLocaleString('en-IN'); }
  function openEl(sel){ var el=$(sel); if(el) el.classList.add('open'); }
  function closeEl(sel){ var el=$(sel); if(el) el.classList.remove('open'); }

  /* ================= PER-PAGE (re-run after every Swup swap) ================= */
  var _revealIO, _themeIO, _countIO, _defaultSizeRows = null;

  function initReveals(){
    if(_revealIO) _revealIO.disconnect();
    _revealIO = new IntersectionObserver(function(ents){
      ents.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); _revealIO.unobserve(e.target); } });
    },{ threshold:.14 });
    $all('.reveal').forEach(function(el){ if(!el.classList.contains('is-in')) _revealIO.observe(el); });
  }

  function applyHeaderTheme(t){
    var header=$('.site-header'); if(!header||!t) return;
    header.classList.toggle('theme-dark', t==='dark');
    header.classList.toggle('theme-light', t==='light');
    var logo=$('.site-header .logo');
    if(logo && logo.dataset.dark && logo.dataset.light){ logo.src = t==='dark' ? logo.dataset.dark : logo.dataset.light; }
  }
  function initHeaderTheme(){
    if(_themeIO) _themeIO.disconnect();
    var sections=$all('[data-theme]'); if(!sections.length) return;
    applyHeaderTheme(sections[0].getAttribute('data-theme'));
    _themeIO=new IntersectionObserver(function(ents){
      ents.forEach(function(e){ if(e.isIntersecting) applyHeaderTheme(e.target.getAttribute('data-theme')); });
    },{ rootMargin:'-6% 0px -94% 0px', threshold:0 });
    sections.forEach(function(s){ _themeIO.observe(s); });
  }

  function initCountUps(){
    if(_countIO) _countIO.disconnect();
    var els=$all('[data-countup]'); if(!els.length) return;
    _countIO=new IntersectionObserver(function(ents){
      ents.forEach(function(e){ if(!e.isIntersecting) return; var el=e.target; _countIO.unobserve(el);
        var target=parseFloat(el.getAttribute('data-countup')), dec=(el.getAttribute('data-decimals')|0);
        var prefix=el.getAttribute('data-prefix')||'', suffix=el.getAttribute('data-suffix')||'';
        var dur=1400, start=performance.now();
        function tick(now){ var p=Math.min(1,(now-start)/dur), eased=1-Math.pow(1-p,3);
          el.textContent=prefix+Number((target*eased).toFixed(dec)).toLocaleString('en-IN')+suffix;
          if(p<1) requestAnimationFrame(tick); }
        requestAnimationFrame(tick);
      });
    },{ threshold:.4 });
    els.forEach(function(el){ _countIO.observe(el); });
  }

  // Size guide is global (outside the Swup container) so it must be re-synced to
  // whichever product is on screen after every navigation. A product carries its
  // own chart as JSON in data-size-chart="[[size,c1in,c2in,c3in,c4in,c1cm,c2cm,c3cm,c4cm],...]".
  function syncSizeGuide(){
    var tbody=$('#size-guide tbody'); if(!tbody) return;
    if(_defaultSizeRows===null) _defaultSizeRows=tbody.innerHTML;
    var pdp=$('[data-product]');
    var chart=pdp && pdp.getAttribute('data-size-chart');
    var headName=$('#size-guide [data-sg-product]');
    if(headName){ headName.textContent = pdp ? (pdp.getAttribute('data-title')||'') : ''; headName.style.display = (pdp && pdp.getAttribute('data-title')) ? '' : 'none'; }
    if(chart){
      try{
        var rows=JSON.parse(chart);
        tbody.innerHTML=rows.map(function(r){
          return '<tr><td>'+r[0]+'</td>'+
            '<td data-in="'+r[1]+'" data-cm="'+r[5]+'">'+r[1]+'</td>'+
            '<td data-in="'+r[2]+'" data-cm="'+r[6]+'">'+r[2]+'</td>'+
            '<td data-in="'+r[3]+'" data-cm="'+r[7]+'">'+r[3]+'</td>'+
            '<td data-in="'+r[4]+'" data-cm="'+r[8]+'">'+r[4]+'</td></tr>';
        }).join('');
      }catch(e){ tbody.innerHTML=_defaultSizeRows; }
    } else {
      tbody.innerHTML=_defaultSizeRows;
    }
  }

  function refreshPageBehaviors(){
    initReveals();
    initHeaderTheme();
    initCountUps();
    syncSizeGuide();
    registerInventory();
    initAccount();
  }
  function registerInventory(){
    window.Andheka.inv = window.Andheka.inv || {};
    var pdp=$('[data-product]'); if(!pdp) return;
    try{
      var vs=JSON.parse(pdp.getAttribute('data-variants')||'{}');
      Object.keys(vs).forEach(function(sz){ var r=vs[sz]; if(r && r.id!==undefined && r.inv!==undefined) window.Andheka.inv[r.id]=r.inv; });
    }catch(e){}
  }
  /* ---- account dashboard: hourly greeting, the light dial, quick-add ---- */
  function initAccount(){
    var sec=document.getElementById('account-dash'); if(!sec) return;
    var greetEl=sec.querySelector('[data-acc-greet]'), subEl=sec.querySelector('[data-acc-sub]');
    var name=sec.getAttribute('data-name')||'you';
    var h=new Date().getHours();
    var part = h<12 ? 'morning' : (h<17 ? 'afternoon' : 'evening');
    var manual=null; try{ manual=localStorage.getItem('andheka-corner'); }catch(e){}
    var autoDark = (h>=18 || h<7);
    // manual choice themes the whole session (bag follows); the hourly default themes only this page
    if(manual){ document.documentElement.setAttribute('data-corner', manual); sec.removeAttribute('data-corner-local'); }
    else { sec.setAttribute('data-corner-local', autoDark ? 'dark' : 'light'); }
    if(greetEl && greetEl.dataset.done!=='1'){ greetEl.textContent='Good '+part+', '+name+'.'; greetEl.dataset.done='1'; }
    function curCorner(){ return document.documentElement.getAttribute('data-corner') || sec.getAttribute('data-corner-local') || 'light'; }
    function setSub(){ if(!subEl) return;
      var manual=document.documentElement.getAttribute('data-corner');
      if(manual){ subEl.textContent = (curCorner()==='dark') ? 'Dimmed, the way you like it.' : 'Bright, the way you like it.'; }
      else { subEl.textContent = autoDark ? 'Dimmed for the hour.' : 'Bright for the hour.'; } }
    var dial=sec.querySelector('[data-dial]'), hint=sec.querySelector('[data-dial-hint]');
    var ring=dial ? dial.querySelector('.dial-ring') : null;
    function setHint(){ if(hint) hint.textContent = curCorner()==='dark' ? 'Turn for day' : 'Turn for night'; }
    function render(p){ if(!dial) return; dial.style.setProperty('--a',(-128+p*256)+'deg'); if(ring) ring.style.transform='rotate('+(-120+p*240)+'deg)'; }
    setSub(); setHint(); render(curCorner()==='dark'?1:0);
    function choose(val){ document.documentElement.setAttribute('data-corner', val); sec.removeAttribute('data-corner-local'); try{localStorage.setItem('andheka-corner',val);}catch(e){} setSub(); setHint(); render(val==='dark'?1:0); }
    function toggle(){ choose(curCorner()==='dark' ? 'light' : 'dark'); }
    function previewCorner(dark){ document.documentElement.setAttribute('data-corner', dark?'dark':'light'); sec.removeAttribute('data-corner-local'); setSub(); setHint(); }
    if(dial && dial.dataset.bound!=='1'){
      dial.dataset.bound='1';
      var drag=false, moved=false, lastA=0, acc=0;
      function angOf(e){ var r=dial.getBoundingClientRect(); return Math.atan2(e.clientY-(r.top+r.height/2), e.clientX-(r.left+r.width/2))*180/Math.PI; }
      dial.addEventListener('pointerdown', function(e){ drag=true; moved=false; lastA=angOf(e); acc=(curCorner()==='dark'?1:0); dial.classList.add('turning'); try{dial.setPointerCapture(e.pointerId);}catch(_){} });
      dial.addEventListener('pointermove', function(e){ if(!drag) return; var a=angOf(e), d=a-lastA; if(d>180)d-=360; if(d<-180)d+=360; lastA=a; if(Math.abs(d)>2) moved=true; acc=Math.max(0,Math.min(1, acc + d/220)); render(acc); previewCorner(acc>=0.5); });
      dial.addEventListener('pointerup', function(){ if(!drag) return; drag=false; dial.classList.remove('turning'); if(!moved){ toggle(); } else { choose(acc>=0.5 ? 'dark' : 'light'); } });
      dial.addEventListener('lostpointercapture', function(){ drag=false; dial.classList.remove('turning'); });
      dial.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); toggle(); } else if(e.key==='ArrowRight'||e.key==='ArrowDown'){ e.preventDefault(); choose('dark'); } else if(e.key==='ArrowLeft'||e.key==='ArrowUp'){ e.preventDefault(); choose('light'); } });
    }
    if(sec.dataset.addBound!=='1'){
      sec.dataset.addBound='1';
      sec.addEventListener('click', function(e){
        var cc=e.target.closest('[data-copy-code]');
        if(cc){ e.preventDefault(); var code=cc.getAttribute('data-copy-code')||''; try{ navigator.clipboard.writeText(code); }catch(_){}
          var act=cc.querySelector('.cc-act'); if(act && !act.getAttribute('data-busy')){ act.setAttribute('data-busy','1'); var ov=act.textContent; act.textContent='Copied \u2713'; setTimeout(function(){ act.textContent=ov; act.removeAttribute('data-busy'); },1600); } return; }
        var sz=e.target.closest('[data-sc-size]');
        if(sz && !sz.disabled){
          var card=sz.closest('[data-shop-card]'); if(!card) return;
          card.querySelectorAll('[data-sc-size]').forEach(function(x){ x.classList.remove('on'); });
          sz.classList.add('on');
          var addB=card.querySelector('[data-acc-add]');
          if(addB){ addB.setAttribute('data-acc-add', sz.getAttribute('data-sc-size')); addB.disabled=false; if(addB.dataset.added!=='1') addB.textContent='Add to bag'; }
          return;
        }
        var b=e.target.closest('[data-acc-add]'); if(!b || b.disabled) return;
        e.preventDefault(); var id=b.getAttribute('data-acc-add'); if(!id) return;
        var old=b.textContent; b.disabled=true; b.dataset.added='1'; b.textContent='Adding\u2026';
        fetch(window.Andheka.routes.cart_add, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id:id, quantity:1}]})})
          .then(function(r){ return r.json(); })
          .then(function(){ b.textContent='In your bag'; if(window.Andheka.openCart) window.Andheka.openCart(); setTimeout(function(){ b.textContent=old; b.disabled=false; }, 1800); })
          .catch(function(){ b.textContent=old; b.disabled=false; });
      });
    }
  }

  window.Andheka = window.Andheka || {};
  window.Andheka.refreshPageBehaviors = refreshPageBehaviors;

  /* ================= GLOBAL, bind-once, fully delegated ================= */
  function initCursor(){
    if(CFG.cursorEnabled===false) return;
    if(window.matchMedia('(hover: none)').matches) return;
    var dot=document.createElement('div'); dot.className='cur-dot';
    var ring=document.createElement('div'); ring.className='cur-ring';
    var label=document.createElement('div'); label.className='cur-label';
    document.body.appendChild(dot); document.body.appendChild(ring); document.body.appendChild(label);
    document.documentElement.style.cursor='none';
    var mx=innerWidth/2,my=innerHeight/2,rx=mx,ry=my,cs=1,ts=1;
    window.addEventListener('pointermove',function(e){
      mx=e.clientX; my=e.clientY;
      dot.style.transform='translate('+mx+'px,'+my+'px)';
      label.style.transform='translate('+(mx+16)+'px,'+(my+14)+'px)';
      var t=e.target.closest && e.target.closest('[data-cursor], a, button, [role="button"], summary, label, .chip');
      ts=t?1.7:1;
      var txt='';
      if(t){
        if(t.hasAttribute('data-cursor')){ txt=t.getAttribute('data-cursor')||''; }
        else { var dc=t.closest('[data-cursor]'); if(dc){ txt=dc.getAttribute('data-cursor')||''; }
          else if(t.tagName==='A'){ txt='view'; }
          else { txt='select'; } }
      }
      if(label.textContent!==txt) label.textContent=txt;
      label.style.opacity=(t&&txt)?'1':'0';
    },{passive:true});
    (function loop(){ rx+=(mx-rx)*.16; ry+=(my-ry)*.16; cs+=(ts-cs)*.18;
      ring.style.transform='translate('+rx.toFixed(1)+'px,'+ry.toFixed(1)+'px) scale('+cs.toFixed(3)+')';
      requestAnimationFrame(loop); })();
  }

  function initScrollUI(){
    window.addEventListener('scroll', function(){
      var h=document.documentElement, max=(h.scrollHeight-h.clientHeight)||1;
      var bar=$('.progress'); if(bar) bar.style.width=Math.min(100,(window.scrollY||h.scrollTop)/max*100)+'%';
      var buybar=$('.buybar'); if(buybar) buybar.classList.toggle('show', window.scrollY>520);
    },{passive:true});
  }

  /* ---- Shopify cart ---- */
  function postJSON(url,body){ return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){ return r.json().then(function(d){ return {ok:r.ok, data:d}; }); }); }
  function getCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }
  function addToCart(id,qty){
    return postJSON('/cart/add.js',{items:[{id:id,quantity:qty||1}]}).then(function(res){
      if(!res.ok){ showToast((res.data && res.data.description) || 'That\u2019s all we have in that size'); throw res; }
      return res.data;
    });
  }
  function changeLine(key,qty){
    return postJSON('/cart/change.js',{id:key,quantity:qty}).then(function(res){
      var cart=res.data;
      var line=(cart.items||[]).filter(function(it){return it.key===key;})[0];
      if(qty>0 && line && line.quantity<qty){ showToast('That\u2019s all we have in that size'); }
      return cart;
    });
  }
  function thumb(url,w){ if(!url) return ''; return url.indexOf('?')>-1 ? url+'&width='+w : url+'?width='+w; }
  function renderCart(cart){
    var items=$('.drawer .items'); if(!items) return;
    $all('[data-cart-count]').forEach(function(el){ el.textContent=cart.item_count; });
    if(!cart.items.length){
      items.innerHTML='<p class="empty">Your bag is quiet for now. The pieces are waiting whenever you\u2019re ready.</p>';
    } else {
      items.innerHTML=cart.items.map(function(it){
        var size=(it.variant_title||'').split(' / ')[0]||it.variant_title||'';
        var szLine=(size&&size!=='Default Title')?('Size '+size):'';
        return '<div class="line-item" data-key="'+it.key+'" data-vid="'+it.variant_id+'">'+
          '<a class="li-thumb" href="'+it.url+'" data-cursor="view">'+(it.image?('<img src="'+thumb(it.image,200)+'" alt="">'):'')+'</a>'+
          '<div class="t">'+
            '<a class="name" href="'+it.url+'" data-cursor="view">'+it.product_title+'</a>'+
            '<div class="sz">'+szLine+'</div>'+
            '<div class="li-controls"><div class="qty"><button data-qty="dec" data-cursor="less">\u2212</button><span>'+it.quantity+'</span><button data-qty="inc" data-cursor="more">+</button></div><button class="rm" data-qty="rm" data-cursor="release">Remove</button></div>'+
          '</div>'+
          '<div class="price">'+formatMoney(it.final_line_price)+'</div>'+
        '</div>';
      }).join('');
    }
    var sub=$('.drawer .sub .v'); if(sub) sub.textContent=formatMoney(cart.total_price);
    renderUpsell(cart);
  }
  function renderUpsell(cart){
    var wrap=$('.cart-upsell'); if(!wrap) return;
    if(!cart.items.length){ wrap.innerHTML=''; return; }
    var inCart={}; cart.items.forEach(function(it){ inCart[it.product_id]=true; });
    var pid=cart.items[0].product_id;
    fetch('/recommendations/products.json?product_id='+pid+'&limit=4&intent=related',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(d){
        var rec=(d.products||[]).filter(function(p){ return !inCart[p.id] && p.available; })[0];
        if(!rec){ wrap.innerHTML=''; return; }
        var v=(rec.variants||[]).filter(function(x){return x.available;})[0]||rec.variants[0];
        wrap.innerHTML='<div class="upsell-head">You may also like</div>'+
          '<div class="upsell-row">'+
            '<a class="li-thumb" href="'+rec.url+'" data-cursor="view">'+(rec.featured_image?('<img src="'+thumb(rec.featured_image,200)+'" alt="">'):'')+'</a>'+
            '<div class="t"><a class="name" href="'+rec.url+'" data-cursor="view">'+rec.title+'</a><div class="sz">'+formatMoney(rec.price)+'</div></div>'+
            '<button class="upsell-add" data-upsell-add="'+(v?v.id:'')+'" data-cursor="add">Add</button>'+
          '</div>';
      }).catch(function(){ wrap.innerHTML=''; });
  }
  function refreshCart(){ return getCart().then(renderCart).catch(function(){}); }

  var toastT;
  function showToast(msg){
    var t=$('.toast'); if(!t) return;
    var m=$('.toast .msg',t); if(m) m.textContent=msg;
    t.classList.add('show');
    clearTimeout(toastT); toastT=setTimeout(function(){ t.classList.remove('show'); },3400);
  }

  function initDelegatedEvents(){
    document.addEventListener('click', function(e){
      // account dropdown (logged-in) — our own, fast, on-brand
      var at=e.target.closest('[data-acct-menu]');
      if(at){ e.preventDefault(); e.stopPropagation(); var aw=at.closest('.acct-wrap'); var aon=aw.classList.toggle('open'); at.setAttribute('aria-expanded', aon?'true':'false'); return; }
      if(!e.target.closest('.acct-wrap')){ var aop=document.querySelector('.acct-wrap.open'); if(aop){ aop.classList.remove('open'); var ab=aop.querySelector('[data-acct-menu]'); if(ab) ab.setAttribute('aria-expanded','false'); } }
      // overlays
      var o=e.target.closest('[data-open]');
      if(o){ e.preventDefault(); e.stopPropagation(); var t=o.getAttribute('data-open');
        if(t==='cart'){ openEl('.drawer-backdrop'); openEl('.drawer'); refreshCart(); }
        else if(t==='menu'){ openEl('.menu-overlay'); }
        else if(t==='account'){ closeEl('.menu-overlay'); openEl('.account-overlay'); }
        else if(t==='size-guide'){ openEl('.sg'); }
        return; }
      var c=e.target.closest('[data-close]');
      if(c){ e.preventDefault(); var ct=c.getAttribute('data-close');
        if(ct==='cart'){ closeEl('.drawer'); closeEl('.drawer-backdrop'); }
        else if(ct==='menu'){ closeEl('.menu-overlay'); }
        else if(ct==='account'){ closeEl('.account-overlay'); }
        else if(ct==='size-guide'){ closeEl('.sg'); } }

      // account overlay tab switch (email / phone)
      var accTab=e.target.closest('[data-acc-tab]');
      if(accTab){
        var which=accTab.getAttribute('data-acc-tab'); var ov=accTab.closest('.account-overlay');
        $all('[data-acc-tab]',ov).forEach(function(t2){ t2.classList.toggle('is-on', t2===accTab); });
        $all('[data-acc-pane]',ov).forEach(function(pane){ pane.hidden = pane.getAttribute('data-acc-pane')!==which; });
      }

      // cart qty / remove
      var qtyBtn=e.target.closest('[data-qty]');
      if(qtyBtn){
        var li=qtyBtn.closest('.line-item'); var key=li && li.getAttribute('data-key');
        var span=li && li.querySelector('.qty span'); var cur=parseInt(span?span.textContent:'1',10);
        var act=qtyBtn.getAttribute('data-qty');
        var next=act==='inc'?cur+1:act==='dec'?Math.max(0,cur-1):0;
        if(key){
          // enforce known inventory (from any product we've rendered this session)
          var vid=li && parseInt(li.getAttribute('data-vid'),10);
          var invMap=window.Andheka.inv||{};
          if(act==='inc' && vid && invMap[vid]!==undefined && next>invMap[vid]){
            showToast(invMap[vid]<=0 ? 'That size is sold out' : 'That\u2019s all we have \u2014 only '+invMap[vid]+' left');
            return;
          }
          if(span && next>0){ span.textContent=next; }        // optimistic: no wait/lag
          if(next===0 && li){ li.style.opacity='.4'; }
          changeLine(key,next).then(renderCart);
        }
      }

      // size-guide unit toggle
      var unitBtn=e.target.closest('[data-unit]');
      if(unitBtn){
        var sg=unitBtn.closest('.sg');
        $all('.seg button',sg).forEach(function(x){ x.classList.toggle('on',x===unitBtn); });
        var unit=unitBtn.getAttribute('data-unit');
        $all('td[data-in]',sg).forEach(function(td){ td.textContent = unit==='cm' ? td.getAttribute('data-cm') : td.getAttribute('data-in'); });
      }

      // product: size chip select
      var chip=e.target.closest('[data-sizechip]');
      if(chip && !chip.classList.contains('soldout')){
        var pid=chip.getAttribute('data-pid');
        $all('[data-sizechip][data-pid="'+pid+'"]').forEach(function(c2){ c2.classList.toggle('sel', c2===chip); });
        $all('.size-hint[data-pid="'+pid+'"]').forEach(function(h){ h.classList.remove('show'); });
      }

      // product: add to bag (variant map read from data-variants on [data-product])
      var add=e.target.closest('[data-add]');
      if(add){
        var pid2=add.getAttribute('data-pid');
        var sel=$('[data-sizechip][data-pid="'+pid2+'"].sel');
        if(!sel){
          $all('.size-hint[data-pid="'+pid2+'"]').forEach(function(h){ h.classList.add('show'); });
          var row=$('.size-row[data-pid="'+pid2+'"]');
          if(row&&row.animate) row.animate([{transform:'translateX(0)'},{transform:'translateX(-7px)'},{transform:'translateX(7px)'},{transform:'translateX(0)'}],{duration:320});
          showToast('Please choose a size first');
          return;
        }
        var pdpEl=$('[data-product="'+pid2+'"]');
        var variants={}; try{ variants=JSON.parse((pdpEl && pdpEl.getAttribute('data-variants'))||'{}'); }catch(err){}
        var vrec=variants[sel.getAttribute('data-size')];
        var vid=vrec && (vrec.id!==undefined ? vrec.id : vrec); // supports {id,inv} or bare id
        var vinv=vrec && vrec.inv!==undefined ? vrec.inv : 9999;
        if(!vid){ showToast('That size is unavailable'); return; }
        // how many of this exact variant are already in the bag?
        getCart().then(function(cart){
          var already=0; (cart.items||[]).forEach(function(it){ if(it.variant_id===vid) already=it.quantity; });
          if(already+1 > vinv){ showToast(vinv<=0 ? 'That size is sold out' : 'That\u2019s all we have \u2014 only '+vinv+' left'); return; }
          addToCart(vid,1).then(refreshCart).then(function(){
            showToast('Added \u2014 '+(pdpEl?pdpEl.getAttribute('data-title'):'')+' \u00b7 '+sel.getAttribute('data-size'));
            var bc=$('[data-cart-count]'); if(bc&&bc.animate) bc.animate([{transform:'scale(1)'},{transform:'scale(1.45)'},{transform:'scale(1)'}],{duration:450});
          }).catch(function(){});
        });
      }

      // cart upsell add
      var up=e.target.closest('[data-upsell-add]');
      if(up){
        var uvid=up.getAttribute('data-upsell-add');
        if(uvid){ addToCart(uvid,1).then(refreshCart).then(function(){ showToast('Added to your bag'); }).catch(function(){}); }
      }

      // clicking a product link inside the cart drawer: close it, let Swup navigate
      if(e.target.closest('.drawer .line-item a, .drawer .upsell-row a')){ closeEl('.drawer'); closeEl('.drawer-backdrop'); }

      // locked ("coming soon") overlay chapter
      if(e.target.closest('.menu-chapters .soon')){ showToast('This chapter arrives soon. Stay close.'); }

      // easter egg: triple-tap footer copyright (mobile)
      if(e.target.closest('[data-egg-tap]')) handleEggTap();
    });

    document.addEventListener('change', function(e){
      if(e.target && e.target.classList && e.target.classList.contains('loc__select')){
        var f=e.target.closest('form'); if(f) f.submit();
      }
    });

    // localization dropdown open/close
    document.addEventListener('click', function(e){
      var tog=e.target.closest('[data-loc-toggle]');
      var loc=tog && tog.closest('[data-loc]');
      // close any open dropdowns not being toggled
      $all('[data-loc].open').forEach(function(el){ if(el!==loc){ el.classList.remove('open'); var t=$('[data-loc-toggle]',el); if(t) t.setAttribute('aria-expanded','false'); } });
      if(loc){ var willOpen=!loc.classList.contains('open'); loc.classList.toggle('open',willOpen); tog.setAttribute('aria-expanded', willOpen?'true':'false'); }
    });

    document.addEventListener('submit', function(e){
      var form=e.target;
      if(!form || !form.matches) return;
      if(form.matches('form[data-klaviyo-list]')){
        e.preventDefault();
        var list=form.getAttribute('data-klaviyo-list');
        var emailInput=form.querySelector('input[type=email]');
        var email=emailInput?emailInput.value:'';
        if(!list||!email){ showToast('Add your email'); return; }
        var body='g='+encodeURIComponent(list)+'&email='+encodeURIComponent(email)+'&$fields=email';
        fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe',{ method:'POST', headers:{'Content-Type':'application/x-www-form-urlencoded'}, body:body })
          .then(function(){ showToast('Thank you \u2014 we\u2019ll write when it matters'); form.reset(); })
          .catch(function(){ showToast('Thank you \u2014 we\u2019ll write when it matters'); form.reset(); });
      } else if(form.matches('form[data-news="ack"]')){
        setTimeout(function(){ showToast('Thank you \u2014 we\u2019ll write when it matters'); },50);
      }
    });

    document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ ['.menu-overlay','.drawer','.drawer-backdrop','.sg','.account-overlay'].forEach(closeEl); var ao=document.querySelector('.acct-wrap.open'); if(ao){ ao.classList.remove('open'); var ab2=ao.querySelector('[data-acct-menu]'); if(ab2) ab2.setAttribute('aria-expanded','false'); } $all('[data-loc].open').forEach(function(el){ el.classList.remove('open'); }); } });

    var bd=$('.drawer-backdrop'); if(bd) bd.addEventListener('click', function(){ closeEl('.drawer'); closeEl('.drawer-backdrop'); });
  }

  /* ---- easter eggs (global, bind once) ---- */
  var _eggTaps=0, _eggTapT, _eggT;
  function handleEggTap(){
    _eggTaps++; clearTimeout(_eggTapT); _eggTapT=setTimeout(function(){ _eggTaps=0; },1200);
    if(_eggTaps>=3){ _eggTaps=0; revealEgg(); }
  }
  function revealEgg(){ var egg=$('.egg'); if(!egg) return; egg.classList.add('show'); clearTimeout(_eggT); _eggT=setTimeout(function(){ egg.classList.remove('show'); },4200); }
  function initEggs(){
    try{
      console.log('%c  andheka \u2014 the unseen  ','background:#17322E;color:#F8F7F5;padding:6px 12px;font-family:monospace;letter-spacing:3px;');
      console.log('%c\u201cAnd if no one notices, that\u2019s okay. It was never meant to be loud.\u201d','color:#8B968F;font-style:italic;font-family:monospace;');
    }catch(e){}
    var still=$('.still'), idleT, idleMs=CFG.idleMs||15000, whisper=CFG.idleWhisper!==false;
    function reset(){ if(still) still.classList.remove('show'); clearTimeout(idleT); if(!whisper) return;
      idleT=setTimeout(function(){ if(still && !$('.menu-overlay.open') && !$('.drawer.open') && !$('.sg.open')) still.classList.add('show'); }, idleMs); }
    ['pointermove','scroll','keydown','click','touchstart'].forEach(function(ev){ window.addEventListener(ev,reset,{passive:true}); });
    reset();
    var buf='';
    window.addEventListener('keydown', function(e){ if(!e.key||e.key.length!==1) return; buf=(buf+e.key.toLowerCase()).slice(-7); if(buf==='andheka') revealEgg(); });

    // Mobile easter egg: long-press (1.1s) anywhere on the logo/wordmark reveals the unseen
    var pressT;
    function startPress(t){ if(!t.closest) return; if(!t.closest('.site-header .logo, .site-header a[aria-label]')) return; pressT=setTimeout(revealEgg, 1100); }
    function endPress(){ clearTimeout(pressT); }
    document.addEventListener('touchstart', function(e){ startPress(e.target); }, {passive:true});
    document.addEventListener('touchend', endPress, {passive:true});
    document.addEventListener('touchmove', endPress, {passive:true});
  }

  /* ---- loader system: threshold / landing / Swup wipe ---- */
  function initLoaderAndSwup(){
    var loader=$('#route-loader');
    var threshold=$('#threshold');
    var minMs=CFG.loaderMinMs||600;
    var entered=false;
    try{ entered=localStorage.getItem('andheka_entered')==='1'; }catch(e){}

    function revealLanding(){
      if(!loader) return;
      var t0=performance.now();
      function go(){ var wait=Math.max(0,minMs-(performance.now()-t0)); setTimeout(function(){ loader.classList.add('hide'); }, wait); }
      if(document.readyState==='complete') go(); else window.addEventListener('load', go);
    }

    if(threshold && !entered){
      if(loader) loader.classList.add('hide');
      threshold.classList.add('show');
      var done=false;
      function enter(){ if(done) return; done=true;
        try{ localStorage.setItem('andheka_entered','1'); }catch(e){}
        threshold.classList.add('lift');
        setTimeout(function(){ threshold.classList.add('hide'); }, 1100);
      }
      var btn=threshold.querySelector('[data-threshold-enter]');
      if(btn) btn.addEventListener('click', enter);
      window.addEventListener('wheel', enter, {passive:true, once:true});
      window.addEventListener('touchmove', enter, {passive:true, once:true});
      window.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' ') enter(); });
      setTimeout(enter, CFG.thresholdAutoMs||14000);
    } else {
      if(threshold) threshold.classList.add('hide');
      revealLanding();
    }

    window.addEventListener('pageshow', function(e){ if(e.persisted){ if(loader) loader.classList.add('hide'); if(threshold) threshold.classList.add('hide'); } });

    if(CFG.swupEnabled===false) return; // user disabled: normal navigation
    if(window.Shopify && window.Shopify.designMode) return; // never intercept nav inside the theme editor

    // Swup may still be loading (deferred CDN script). Wait for it, then init.
    function startSwup(){
      if(typeof window.Swup==='undefined') return false;
      var swup=new window.Swup({
        containers:['#main-content'],
        animationSelector:'#wipe',       // Swup measures THIS element's CSS transition and waits for it
        animateHistoryBrowsing:true,
        linkSelector:'a[href]:not([data-no-swup]):not([data-open]):not([target="_blank"]):not([href^="mailto:"]):not([href^="tel:"])',
        ignoreVisit:function(url, ctx){ var el=ctx && ctx.el; return !!(el && el.closest && el.closest('[data-no-swup],[data-open]')); }
      });
      window.Andheka.swup=swup;
      // Swup drives the wipe purely through the CSS classes on <html>; we only
      // refresh per-page behaviours the moment the new content is in the DOM.
      swup.hooks.on('content:replace', function(){ window.scrollTo(0,0); refreshPageBehaviors(); });
      return true;
    }
    if(!startSwup()){
      var tries=0, iv=setInterval(function(){ tries++; if(startSwup() || tries>60) clearInterval(iv); }, 50);
      window.addEventListener('load', startSwup);
    }
  }

  function boot(){
    initCursor();
    initScrollUI();
    initDelegatedEvents();
    initEggs();
    refreshPageBehaviors();
    initLoaderAndSwup();
    refreshCart();
    window.Andheka.addToCart=addToCart;
    window.Andheka.refreshCart=refreshCart;
    window.Andheka.showToast=showToast;
    window.Andheka.openCart=function(){ openEl('.drawer-backdrop'); openEl('.drawer'); refreshCart(); };
  }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
